import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
}

export const CardIcon: React.FC<IconProps> = ({
  color = '#fff',
  size = 28,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 29 28"
    fill="none"
    className={className}
    {...rest}
  >
    <rect
      x={3}
      y={4.5}
      width={23}
      height={18}
      rx={4.5}
      stroke={color}
      strokeWidth={3}
      opacity={color ? 1 : 0.4}
    />
    <path
      d="M7 10.5C7 9.67157 7.67157 9 8.5 9H11.5C12.3284 9 13 9.67157 13 10.5C13 11.3284 12.3284 12 11.5 12H8.5C7.67157 12 7 11.3284 7 10.5Z"
      fill={color}
      opacity={color ? 1 : 0.4}
    />
  </svg>
)
